var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "FormDropDownList" } }, [
    _c("div", { class: "form-drop-downList dropdown-align-" + _vm.align }, [
      _c("label", { staticClass: "form-drop-down-title" }, [
        _vm._v("\n            " + _vm._s(_vm.displayFieldLabel) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedOption,
                expression: "selectedOption",
              },
            ],
            staticClass: "form-drop-down-select",
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedOption = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.updateField,
              ],
              blur: _vm.updateField,
            },
          },
          [
            _c("option", { attrs: { disabled: "", value: "" } }, [
              _vm._v(_vm._s(_vm.placeholder || "Seçiniz...")),
            ]),
            _vm._v(" "),
            _vm._l(_vm.options, function (option) {
              return _c(
                "option",
                { key: option, domProps: { value: option } },
                [_vm._v(_vm._s(option))]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "options-management" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newOptions,
                expression: "newOptions",
              },
            ],
            staticClass: "form-drop-down-textarea",
            attrs: { placeholder: "seçenek 1&#10;seçenek 2" },
            domProps: { value: _vm.newOptions },
            on: {
              blur: _vm.addOptions,
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newOptions = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "form-drop-down-button",
              on: { click: _vm.addOptions },
            },
            [_vm._v("Seçenek Ekle")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "form-drop-down-button",
              on: { click: _vm.toggleOptions },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.showOptions ? "Seçenekleri Gizle" : "Seçenekleri Göster"
                  ) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showOptions
            ? _c(
                "div",
                { staticClass: "remove-options" },
                _vm._l(_vm.options, function (option) {
                  return _c(
                    "div",
                    { key: option, staticClass: "option-item" },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(option) +
                          "\n                        "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "remove-button",
                          on: {
                            click: function ($event) {
                              return _vm.removeOption(option)
                            },
                          },
                        },
                        [
                          _c("md-icon", { staticStyle: { color: "white" } }, [
                            _vm._v("delete"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localAltLabel,
              expression: "localAltLabel",
            },
          ],
          staticClass: "form-drop-down-sublabel",
          attrs: { type: "text" },
          domProps: { value: _vm.localAltLabel },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localAltLabel = $event.target.value
              },
              _vm.updateField,
            ],
            blur: _vm.updateField,
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }